var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
if(typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");
var AbstractPosAngleInteractionModel = require("./../../../abstract/abstractPosAngleInteractionModel.js");
var cio_config = require("cio-config");

var TextInteractionModel = function(textData, editorModel, options) {
    AbstractPosAngleInteractionModel.call(this, textData, editorModel);

    this.boundingBox = this.data.boundingBox;
    //TODO: Figure how to pass options from shapeWrapper
    this.options = options || {units: []};

    this.mirrored = this.value("mirrored", true);

    if(this.options.mirrored) this.mirrored(true);

    this.checkedFontSize = this.shadow("checkedFontSize",
        function(){
            return parseFloat(this.data.fontSize()) * this.data.getFontFactor();
        },
        function(fontSize){
            return this.data.fontSize(fontSize / this.data.getFontFactor());
        },
        [this.data.fontSize, this.data.fontUnit]
    );
    this.showHorizontalAlignment = this.shadow("showHorizontalAlignment",
        function () {
            return this.data.anchor();
        },
        function (val) {
            return this.data.anchor(val);
        },
        [this.data.anchor]
    );
    this.showVerticalAlignment = this.shadow("showVerticalAlignment",
        function () {
            return this.data.alignment();
        },
        function (val) {
            return this.data.alignment(val);
        },
        [this.data.alignment]
    );
    this.keepReadable = this.shadow("keepReadable", 
        function () {
            return this.data.keepReadable();
        },
        function(val) {
            return this.data.keepReadable(val);
        },
        [this.data.keepReadable]
    );
};
lib_core.inherit(TextInteractionModel, AbstractPosAngleInteractionModel);
lib_core.JsonParser.registerClass(TextInteractionModel, "TextInteractionModel");

module.exports = TextInteractionModel;

TextInteractionModel.prototype.getInspectorElements = function () {
    var inspectorElements = AbstractPosAngleInteractionModel.prototype.getInspectorElements.call(this);

    inspectorElements.input_elements.unshift({
            label       : 'Text',
            type        : ui_extensions.InspectorInputType.TEXT,
            datamember  : this.data.text,
            update_while_typing: true
        });

    if(this.options.units.length > 1){
        inspectorElements.input_elements.push({
                label           : 'Font size',
                type            : ui_extensions.InspectorInputType.VALUE_AND_UNIT,
                datamember      : this.checkedFontSize,
                datatype        : cio_config.types.positive_float,
                unitmember      : this.data.fontUnit,
                allowed_units   : this.options.units
            });
    }else{
        inspectorElements.input_elements.push({
            label      : 'Font size',
            type       : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember : this.checkedFontSize,
            datatype   : cio_config.types.positive_float,
            unit       : this.data.fontUnit()
        });
    }
    inspectorElements.input_elements.push({
        label      : 'Horizontal Alignment',
        type       : ui_extensions.InspectorInputType.SELECTBOX,
        datamember : this.showHorizontalAlignment,
        list       : [["Left"     , "start"],
                      ["Center"   , "middle"],
                      ["Right"    , "end"]]
    });
    inspectorElements.input_elements.push({
        label      : 'Vertical Alignment',
        type       : ui_extensions.InspectorInputType.SELECTBOX,
        datamember : this.showVerticalAlignment,
        list       : [["Baseline" , "baseline"],
                      ["Central"  , "central"],
                      ["Top"      , "hanging"]]
    });
    inspectorElements.input_elements.push({
        label      : 'Keep Readable',
        type       : ui_extensions.InspectorInputType.CHECKBOX,
        datamember : this.keepReadable
    });

    inspectorElements.help_elements = {
        'name': 'Text'
    };

    return inspectorElements;
};
